import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogConfig,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { NewRelationsStore, RelationsStore } from '@qtek/libs/store';
import { TranslationCoreModule } from '@qtek/libs/translation-core';
import {
  DialogActionsDirective,
  DialogComponent,
  DialogContentDirective,
  DialogTitleDirective,
} from '@qtek/shared/components';
import { Customer, InvitationStatuses, Person } from '@qtek/shared/models';
import { CustomValidators } from '@qtek/shared/utils';
import { fullscreenClass, minWidth } from '../../default-config';

export interface InviteContactDialogInput {
  type: 'staff' | 'customer';
  relId?: string;
  person?: Person;
  customer?: Customer;
}

export const inviteContactDialogConfig: MatDialogConfig = {
  width: minWidth,
  panelClass: fullscreenClass,
};

@Component({
  selector: 'qt-invite-contact-dialog',
  templateUrl: './invite-contact-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslationCoreModule,
    DialogComponent,
    DialogTitleDirective,
    DialogContentDirective,
    DialogActionsDirective,
    MatButtonModule,
    MatDialogModule,
  ],
})
export class InviteContactDialogComponent {
  data = inject<InviteContactDialogInput>(MAT_DIALOG_DATA);
  private mdDialogRef =
    inject<MatDialogRef<InviteContactDialogComponent>>(MatDialogRef);
  private newRelationsStore = inject(NewRelationsStore);
  private relationsStore = inject(RelationsStore);
  private fb = inject(UntypedFormBuilder);

  form: UntypedFormGroup;

  createForm(): void {
    this.form = this.fb.group({
      sendingMethod: this.fb.group(
        {
          email: this.fb.control({
            value: this.checkEmail(),
            disabled: !this.checkEmail(),
          }),
          sms: this.fb.control({
            value: this.checkPhone(),
            disabled: !this.checkPhone(),
          }),
        },
        {
          validator: CustomValidators.atLeastOne,
        }
      ),
    });
  }

  checkEmail(): boolean {
    return this.data.person.email !== null;
  }

  checkPhone(): boolean {
    return this.data.person.phoneList && this.data.person.phoneList.length > 0;
  }

  onSubmit(): void {
    if (this.data.type === 'customer') {
      let invitationStatus = this.data.customer.invitationStatus;
      if (invitationStatus === InvitationStatuses.DECLINED) {
        invitationStatus = InvitationStatuses.PENDING;
      }

      const payload = {
        _id: this.data.relId,
        email: this.data.customer.email,
        invitationStatus,
        send: true,
      };
      this.newRelationsStore.updatePeople(payload);
    } else {
      this.relationsStore.sendStaffInvitation(this.data.relId).subscribe({
        error: () => {
          /* fire-and-forget invitation, mirroring the previous behavior */
        },
      });
    }

    this.mdDialogRef.close(true);
  }
}
